import { AddUserForm } from '@/views/users/users.types';

export const messageBoxErrors: string[] = [ 'cancel', 'close' ];
export const passwordFields: string[] = [ 'password', 'repeatPassword' ];
export const PASSWORD = 'password';
export const TEXT = 'text';

export const initialUserFormState: AddUserForm = {
  firstName: '',
  lastName: '',
  login: '',
  position: '',
  status: 'Active',
  email: '',
  password: '',
  repeatPassword: '',
};
